import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiservicesService } from './apiservices.service';
import { MysteryStripeModal } from '../mystery-school/mystery-school-dashboard/mystery-school-dashboard.component';
import { PerennialStripeModal } from '../perennial-mandalism/perennial-mandalism-dashboard/perennial-mandalism-dashboard.component';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private apiService: ApiservicesService,
    private matSnackBar: MatSnackBar,
    private loaderService: LoaderService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // console.log("next================>", next, state, this.router)

    const routePath = next.routeConfig?.path;
    const cookieName = 'login_user_details';
    const cookieName2 = 'loggedin_user';


    // --- Mystery School Logic ---

    if (routePath == 'change-password' ){
   const cookieValue = this.cookieService.get(cookieName);
      if (!cookieValue) {
        this.router.navigateByUrl('/');
        return false;
      }
      return true;
    }
    if (routePath == 'mystery-school-dashboard') {
      const cookieValue = this.cookieService.get(cookieName);
      if (!cookieValue) {
        this.router.navigateByUrl('/');
        return false;
      }

      let cookieData: any;
      try {
        cookieData = JSON.parse(cookieValue);
      } catch (error) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);
        this.router.navigateByUrl('/');
        return false;
      }

      const userInfo = cookieData?.userinfo;
      if (!userInfo) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);

        this.router.navigateByUrl('/');
        return false;
      }

      const userEmail = userInfo?.email;
      const userId = userInfo?._id;
      const isMysterySchoolUser = userInfo?.is_mystery_school == 1;
      const subscriptionStatus = userInfo?.mystery_school_status;
      const mysterySubscriptionId = userInfo?.mystery_subscription_id;

      if (!isMysterySchoolUser) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);

        this.router.navigateByUrl('/');
        return false;
      }
      console.log('subscriptionStatus mystery', subscriptionStatus);

      if (subscriptionStatus == 'subscription running') {
        console.log('block 1 hit');

        return true;
      } else {
        console.log('block 2 hit');
        if (mysterySubscriptionId) {
          console.log('Initiating Mystery Subscription Flow');
          if (!userEmail || !userId) {
            this.matSnackBar.open(
              'User information missing. Cannot initiate subscription.',
              'Close',
              { duration: 5000 }
            );
            this.cookieService.delete(cookieName);
            this.cookieService.delete(cookieName2);

            this.router.navigateByUrl('/');
            return false;
          }
          this.loaderService.hide();
          this.initiateMysterySubscriptionFlow(userEmail, userId);
          return false;
        } else {
          this.matSnackBar.open(
            'Please contact the main account holder to renew the Mystery School subscription.',
            'Close',
            { duration: 5000 }
          );
          this.loaderService.hide();
          this.cookieService.delete(cookieName);
          this.cookieService.delete(cookieName2);

          this.router.navigateByUrl('/');
          return false;
        }
      }
    }

    // --- Perennial Mandalism Logic ---
    if (routePath == 'perennial-mandalism-dashboard') {
      const cookieValue = this.cookieService.get(cookieName);
      if (!cookieValue) {
        this.router.navigateByUrl('/');
        return false;
      }

      let cookieData: any;
      try {
        cookieData = JSON.parse(cookieValue);
      } catch (error) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);

        this.router.navigateByUrl('/');
        return false;
      }

      const userInfo = cookieData?.userinfo;
      if (!userInfo) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);

        this.router.navigateByUrl('/');
        return false;
      }

      const userEmail = userInfo?.email;
      const userId = userInfo?._id;
      const isPerennialUser = (userInfo?.user_type == 'is_Perennial_Mandalism' || userInfo?.is_perennial_mandalism==1);
      const subscriptionStatus = userInfo?.perennial_mandalism_status;
      const perennialSubscriptionId = userInfo?.perennial_subscription_id;
      console.log('subscriptionStatus perennial', subscriptionStatus);

      if (!isPerennialUser) {
        this.cookieService.delete(cookieName);
        this.cookieService.delete(cookieName2);

        this.router.navigateByUrl('/');
        return false;
      }

      if (subscriptionStatus == 'subscription running') {
        console.log('block 1 hit');
        return true;
      } else {
        console.log('block 2 hit');
        if (perennialSubscriptionId) {
          console.log('Initiating Perennial Subscription Flow');
          if (!userEmail || !userId) {
            this.matSnackBar.open(
              'User information missing. Cannot initiate subscription.',
              'Close',
              { duration: 5000 }
            );
            this.cookieService.delete(cookieName);
            this.cookieService.delete(cookieName2);

            this.router.navigateByUrl('/');
            return false;
          }
          this.loaderService.hide();
          this.initiatePerennialSubscriptionFlow(userEmail, userId);
          return false;
        } else {
          this.matSnackBar.open(
            'Please contact the main account holder to renew the Perennial Mandalism subscription.',
            'Close',
            { duration: 5000 }
          );
          this.loaderService.hide();
          this.cookieService.delete(cookieName);
          this.cookieService.delete(cookieName2);

          this.router.navigateByUrl('/');
          return false;
        }
      }
    }
    // --- divination-certification Logic ---
    if (routePath == 'divination-certification-dashboard' && this.authService.isDivinerAuthenticated())  return true;

    if (
      state.url?.includes('tab') ||
      state.url?.includes('tarot-card') ||
      state.url?.includes('recorded-session')
    ) {
      let urlWithID = state.url;
      sessionStorage.setItem('lastroute', urlWithID);
      console.log('sessionStorage', urlWithID);
    }

    if (
      next.routeConfig?.path == 'admin-dashboard' &&
      this.authService.isAdminAuthenticated()
    )
      return true;
    if (
      next.routeConfig?.path == 'astrologer-dashboard' &&
      (this.authService.isAstrologerAuthenticated() ||
        this.authService.isTarotAuthenticated())
    )
      return true;
    if (
      next.routeConfig?.path == 'customer-dashboard' &&
      this.authService.isSocialAdvoAuthenticated()
    )
      return true;
    // if (next.routeConfig?.path == 'perennial-mandalism-dashboard' && this.authService.isPerrenialAuthenticated()) return true
    // if (next.routeConfig?.path == 'mystery-school-dashboard' && this.authService.isMysterySchoolAuthenticated()) return true
    if (
      next.routeConfig?.path == 'showcasespread' &&
      this.authService.isAstrologerAuthenticated()
    )
      return true;
    if (
      (next.routeConfig?.path == 'horoscope' &&
        this.authService.isAdminAuthenticated()) ||
      this.authService.isAstrologerAuthenticated()
    )
      return true;
    if (
      (next.routeConfig?.path == 'tarot-card' &&
        this.authService.isAdminAuthenticated()) ||
      this.authService.isAstrologerAuthenticated()
    )
      return true;
    if (
      next.routeConfig?.path == 'recorded-session' &&
      this.authService.islogin()
    )
      return true;
    if (next.routeConfig?.path == '') {
      const navigationRoute = this.authService.loggedInNavigation();
      if (navigationRoute) this.router.navigateByUrl(navigationRoute);
      return true;
    }

    this.router.navigateByUrl('/');
    return false;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // if (this.authService.isRouteAuthenticated()) {
    //   return true;
    // }
    // this.router.navigateByUrl('/');
    return false;
  }

  private initiateMysterySubscriptionFlow(email: string, userId: string): void {
    const body = {
      customer_email: email,
      user_id: userId,
    };

    this.apiService
      .getHttpDataPost('stripe/create-subscription-mystery-school', body)
      .subscribe({
        next: (response: any) => {
          if (response.status === 'success' && response.results) {
            this.openMysteryStripeModal({ ...response.results, ...body });
          } else {
            this.matSnackBar.open(
              response.message ||
                'Failed to initiate Mystery School subscription. Please try again.',
              'Close',
              { duration: 5000 }
            );
            this.router.navigateByUrl('/');
          }
        },
        error: (error: any) => {
          const errorMessage =
            error?.error?.message ||
            'An error occurred while initiating Mystery School subscription.';
          this.matSnackBar.open(errorMessage, 'Close', { duration: 5000 });
          this.router.navigateByUrl('/');
        },
      });
  }

  private initiatePerennialSubscriptionFlow(
    email: string,
    userId: string
  ): void {
    const body = {
      customer_id: userId,
      email: email,
    };

    const perennialApiEndpoint = 'cart_management/subscription-payment';

    this.apiService.getHttpDataPost(perennialApiEndpoint, body).subscribe({
      next: (response: any) => {
        if (response.status === 'success' && response.results) {
          let dataObj = {
            clientSecret: response.clientSecret,
            customerId: response.customerId,
            subscriptionId: response.subscriptionId,
          };
          this.openPerennialStripeModal({ ...dataObj, ...body });
        } else {
          this.matSnackBar.open(
            response.message ||
              'Failed to initiate Perennial Mandalism subscription. Please try again.',
            'Close',
            { duration: 5000 }
          );
          this.router.navigateByUrl('/');
        }
      },
      error: (error: any) => {
        const errorMessage =
          error?.error?.message ||
          'An error occurred while initiating Perennial Mandalism subscription.';
        this.matSnackBar.open(errorMessage, 'Close', { duration: 5000 });
        this.router.navigateByUrl('/');
      },
    });
  }

  private openMysteryStripeModal(dataObj: any): void {
    const dialogRef = this.dialog.open(MysteryStripeModal, {
      panelClass: ['custom-modalbox', 'stripe-modalbox'],
      data: {
        dataObj: dataObj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('AuthGuard: Stripe Modal closed with result:', result);
    });
  }

  private openPerennialStripeModal(dataObj: any): void {
    // const cookieName1 = 'login_user_details';
    // const cookieName2 = 'loggedin_user';
    const dialogRef = this.dialog.open(PerennialStripeModal, {
      panelClass: ['custom-modalbox', 'stripe-modalbox'],
      disableClose: true,
      data: {
        dataObj: dataObj,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('AuthGuard: Stripe Modal closed with result:', result);
      // if (!result || result === undefined) {
      //   this.cookieService.delete(cookieName1);
      //   this.cookieService.delete(cookieName2);
      //   this.router.navigateByUrl('/').then(() => {
      //     window.location.reload();
      //   });
      // }
    });
  }
}
